const eachYear = (YEARS) => (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const nonNegative = x => (x > 0 ? x : 0);
const round2 = x => (parseFloat(x).toFixed(2));
const round = x => (parseInt(x, 10));

const getYears = ({ housePrice, futureHousePricePct, percentLoan, years}) => {
  const futureHousePrice = [ housePrice ];
  const amountProtected = [ housePrice ];
  eachYear(years).forEach(y => {
     const prevHousePrice = futureHousePrice[futureHousePrice.length - 1];
     const housePrice = nonNegative(prevHousePrice * (1 + futureHousePricePct * 0.01));
     futureHousePrice.push(housePrice);
     amountProtected.push(housePrice * (1 - percentLoan));
  });
  return {
    futureHousePrice: round(futureHousePrice[futureHousePrice.length - 1]),
    amountProtected: round(amountProtected[amountProtected.length - 1]),
  };
};

const LtvLevel = {
  300: {
    55: 8.00,
    56: 9.00,
    57: 10.00,
    58: 11.50,
    59: 12.50,
    60: 14.00,
    61: 15.00,
    62: 16.00,
    63: 17.00,
    64: 18.00,
    65: 19.50,
    66: 21.00,
    67: 22.00,
    68: 23.00,
    69: 24.50,
    70: 26.00,
    71: 27.00,
    72: 28.00,
    73: 28.50,
    74: 29.00,
    75: 30.00,
    76: 30.50,
    77: 31.00,
    78: 32.00,
    79: 33.00,
    80: 34.00,
    81: 35.00,
    82: 36.00,
    83: 37.00,
    84: 38.00,
  },
  350: {
    55: 10.00,
    56: 11.00,
    57: 12.50,
    58: 13.50,
    59: 14.50,
    60: 15.50,
    61: 16.50,
    62: 17.50,
    63: 19.00,
    64: 20.00,
    65: 21.50,
    66: 23.00,
    67: 24.00,
    68: 25.00,
    69: 26.50,
    70: 28.00,
    71: 29.00,
    72: 30.00,
    73: 30.50,
    74: 31.00,
    75: 32.00,
    76: 32.50,
    77: 33.00,
    78: 34.00,
    79: 35.00,
    80: 36.00,
    81: 37.00,
    82: 38.00,
    83: 39.00,
    84: 40.00,
  },
  400: {
    55: 12.00,
    56: 13.00,
    57: 14.50,
    58: 15.50,
    59: 16.50,
    60: 17.50,
    61: 18.50,
    62: 19.50,
    63: 21.00,
    64: 22.00,
    65: 23.50,
    66: 25.00,
    67: 26.00,
    68: 27.00,
    69: 28.50,
    70: 30.00,
    71: 31.00,
    72: 32.00,
    73: 32.50,
    74: 33.00,
    75: 34.00,
    76: 34.50,
    77: 35.00,
    78: 36.00,
    79: 37.00,
    80: 38.00,
    81: 39.00,
    82: 40.00,
    83: 41.00,
    84: 42.00,
  },
  450: {
    55: 14.00,
    56: 15.00,
    57: 16.50,
    58: 17.50,
    59: 18.50,
    60: 19.50,
    61: 20.50,
    62: 21.50,
    63: 23.00,
    64: 24.00,
    65: 25.50,
    66: 27.00,
    67: 28.00,
    68: 29.00,
    69: 30.50,
    70: 32.00,
    71: 33.00,
    72: 34.00,
    73: 34.50,
    74: 35.00,
    75: 36.00,
    76: 36.50,
    77: 37.00,
    78: 38.00,
    79: 39.00,
    80: 40.00,
    81: 41.00,
    82: 42.00,
    83: 43.00,
    84: 44.00,
  },
  500: {
    55: 17.50,
    56: 18.50,
    57: 19.50,
    58: 20.50,
    59: 21.50,
    60: 22.50,
    61: 23.50,
    62: 24.50,
    63: 25.50,
    64: 26.50,
    65: 27.50,
    66: 28.50,
    67: 30.00,
    68: 31.00,
    69: 32.00,
    70: 33.50,
    71: 34.50,
    72: 35.50,
    73: 36.00,
    74: 37.00,
    75: 38.00,
    76: 39.00,
    77: 40.00,
    78: 41.00,
    79: 42.00,
    80: 43.00,
    81: 44.00,
    82: 45.00,
    83: 46.00,
    84: 47.00,
  },
  550: {
    55: 19.50,
    56: 20.50,
    57: 21.50,
    58: 22.50,
    59: 23.50,
    60: 24.50,
    61: 25.50,
    62: 26.50,
    63: 27.50,
    64: 28.50,
    65: 29.50,
    66: 30.50,
    67: 31.50,
    68: 32.50,
    69: 33.50,
    70: 34.75,
    71: 35.75,
    72: 36.75,
    73: 37.50,
    74: 38.50,
    75: 39.50,
    76: 40.50,
    77: 41.50,
    78: 42.50,
    79: 43.50,
    80: 44.50,
    81: 45.50,
    82: 46.50,
    83: 47.50,
    84: 48.50,
  },
  600: {
    55: 21.00,
    56: 22.00,
    57: 23.00,
    58: 24.00,
    59: 25.00,
    60: 26.00,
    61: 27.00,
    62: 28.00,
    63: 29.00,
    64: 30.00,
    65: 31.00,
    66: 32.00,
    67: 33.00,
    68: 34.00,
    69: 35.00,
    70: 36.00,
    71: 37.00,
    72: 38.00,
    73: 39.00,
    74: 40.00,
    75: 41.00,
    76: 42.00,
    77: 43.00,
    78: 44.00,
    79: 45.00,
    80: 46.00,
    81: 47.00,
    82: 48.00,
    83: 49.00,
    84: 50.00,
  },
  620: {
    55: 22.00,
    56: 23.00,
    57: 24.00,
    58: 25.00,
    59: 26.00,
    60: 27.00,
    61: 28.00,
    62: 29.00,
    63: 30.00,
    64: 31.00,
    65: 32.00,
    66: 33.00,
    67: 34.00,
    68: 35.00,
    69: 36.00,
    70: 37.00,
    71: 38.00,
    72: 39.00,
    73: 40.00,
    74: 41.00,
    75: 42.00,
    76: 43.00,
    77: 44.00,
    78: 45.00,
    79: 46.00,
    80: 47.00,
    81: 48.00,
    82: 49.00,
    83: 50.00,
    84: 51.00,
  },
  680: {
    55: 23.50,
    56: 24.50,
    57: 25.50,
    58: 27.00,
    59: 28.00,
    60: 29.50,
    61: 30.50,
    62: 31.50,
    63: 32.50,
    64: 33.50,
    65: 34.50,
    66: 35.50,
    67: 36.50,
    68: 37.50,
    69: 38.50,
    70: 39.50,
    71: 40.50,
    72: 42.00,
    73: 43.00,
    74: 44.00,
    75: 45.00,
    76: 46.00,
    77: 47.00,
    78: 48.00,
    79: 49.00,
    80: 50.00,
    81: 51.00,
    82: 52.00,
    83: 52.50,
    84: 53.00,
  },
  700: {
    55: 23.70,
    56: 24.70,
    57: 25.80,
    58: 27.60,
    59: 28.60,
    60: 30.50,
    61: 31.50,
    62: 32.50,
    63: 33.50,
    64: 34.50,
    65: 35.50,
    66: 36.50,
    67: 37.50,
    68: 38.50,
    69: 39.50,
    70: 40.50,
    71: 41.50,
    72: 43.00,
    73: 44.00,
    74: 45.00,
    75: 46.00,
    76: 47.00,
    77: 48.00,
    78: 49.00,
    79: 50.00,
    80: 51.00,
    81: 52.00,
    82: 53.00,
    83: 53.20,
    84: 53.40,
  },
  730: {
    55: 24.30,
    56: 25.30,
    57: 26.20,
    58: 28.30,
    59: 29.30,
    60: 31.00,
    61: 32.00,
    62: 33.00,
    63: 34.00,
    64: 35.00,
    65: 36.00,
    66: 37.00,
    67: 38.00,
    68: 39.00,
    69: 40.00,
    70: 41.30,
    71: 42.50,
    72: 43.70,
    73: 44.90,
    74: 46.00,
    75: 47.30,
    76: 48.30,
    77: 49.30,
    78: 50.30,
    79: 50.90,
    80: 51.80,
    81: 53.00,
    82: 53.60,
    83: 53.80,
    84: 54.00,
  },
  780: {
    55: 25.30,
    56: 26.30,
    57: 27.20,
    58: 29.30,
    59: 30.30,
    60: 32.00,
    61: 33.00,
    62: 34.00,
    63: 35.00,
    64: 36.00,
    65: 37.00,
    66: 38.00,
    67: 39.00,
    68: 40.00,
    69: 41.00,
    70: 42.30,
    71: 43.50,
    72: 44.70,
    73: 45.90,
    74: 47.00,
    75: 48.30,
    76: 49.30,
    77: 50.30,
    78: 51.30,
    79: 51.90,
    80: 52.80,
    81: 54.00,
    82: 54.60,
    83: 54.80,
    84: 55.00,
  },
  800: {
    55: 26.30,
    56: 27.30,
    57: 28.20,
    58: 30.30,
    59: 31.30,
    60: 33.00,
    61: 34.00,
    62: 35.00,
    63: 36.00,
    64: 37.00,
    65: 38.00,
    66: 39.00,
    67: 40.00,
    68: 41.00,
    69: 42.00,
    70: 43.30,
    71: 44.50,
    72: 45.70,
    73: 46.90,
    74: 48.00,
    75: 49.30,
    76: 50.30,
    77: 51.30,
    78: 52.30,
    79: 52.90,
    80: 53.80,
    81: 55.00,
    82: 55.60,
    83: 55.80,
    84: 56.00,
  }
};

export const guaranteedInheritanceOutput =  (input) => {
  const { years, totalEquityReleased, clientAge, housePrice, futureHousePricePct, horizonPlan } = input;
  // const level = qualifyForEnhancedLtv ? 'Mild' : 'Standard';
  const level = horizonPlan;
  const maxLoan = round(LtvLevel[level][clientAge] * 0.01 * housePrice);
  const percentLoan = round2(totalEquityReleased / maxLoan);

  const offeredNotTaken = round2(1 - parseFloat(percentLoan));
  const percentProtected = Math.min(offeredNotTaken,
    (input.productChoice === 'prime') ? 1 : 0.5);
  const amountProtectedAtStart = round(percentProtected * housePrice);
  let { amountProtected, futureHousePrice } = getYears({
      years, housePrice, futureHousePricePct,
      percentLoan: 1 - percentProtected });
  return {
     futureHousePrice,
     level,
     maxLoan,
     percentLoan,
     offeredNotTaken,
     amountProtectedAtStart,
     amountProtected,
     percentProtected
  };
};



// WEBPACK FOOTER //
// ./src/services/GuaranteedInheritanceCalc.js